import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { Note } from '@rocksoft/mdm-sdk-v2';
import { NoteComponent } from '../note/note.component';

@Component({
  selector: 'era-notes-list',
  templateUrl: './notes-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NoteComponent],
})
export class NotesListComponent {
  public readonly notes = input<Note[]>([]);

  public readonly noteUpdated = output<Note>();
  public readonly noteRemoved = output<Note>();

  public noteAdded(note: Note): void {
    this.noteUpdated.emit(note);
  }

  public noteDeleted(note: Note): void {
    this.noteRemoved.emit(note);
  }
}
